import { GIF_TYPE, MyFile, PHOTO_TYPE, VIDEO_TYPE } from 'interfaces'
import { ContentType } from 'shared'
import { toCSV } from 'shared/utils/file/csv'

const LIBRARY_CSV_HEADER = ['folder_name', 'file_name', 'file_url']

/**
 * Serialize library files into the CSV format shared by every library export. Keeping the column
 * contract here means the folder view and the whole-library export can never drift apart.
 */
export function libraryFilesToCSV(entries: Array<{ folderName: string, file: MyFile }>) {
  return toCSV([
    LIBRARY_CSV_HEADER,
    ...entries.map(({ folderName, file }) => [folderName, file.name, file.url])
  ])
}

export function getFileThumbUrl(url: string, type: ContentType) {
  if (type === PHOTO_TYPE) {
    return `${url.substring(0, url.lastIndexOf('.')).replace('/o/', '/300xauto/')}.jpg`
  }

  if (type === VIDEO_TYPE || type === GIF_TYPE) {
    return `${url.substring(0, url.lastIndexOf('.')).replace('/o/', '/p/')}.jpg`
  }

  return url
}
